import React from "react";

import styled from "styled-components";
import MUITab from "@mui/material/Tab";

const Tab = styled(({ hidden = false, ...props }) => {
    return <MUITab {...props} classes={{ root: `${hidden ? "hidden" : ""}`, selected: "selected" }} />;
})`
    && {
        flex: 1 1 0;
        min-width: 88px;
        font-weight: normal;
        color: var(--color-grey-800);
        background-color: var(--color-white);
        border: 1px solid var(--color-secondary-light);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        opacity: 1;
        font-size: var(--size-16);
        font-weight: normal;
        line-height: 19px;
        text-transform: uppercase;
    }

    &.selected {
        pointer-events: none;
        cursor: default;
        background-color: var(--color-secondary-light);
        box-shadow: 1px 0 2px rgba(0, 0, 0, 0.15);

        font-weight: bold;
        color: var(--color-secondary);
    }

    &.hidden {
        display: none;
    }
`;

export default Tab;
